var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.11333 5.33329C6.25107 5.72365 6.50649 6.06167 6.8444 6.30077C7.18231 6.53986 7.58606 6.66826 8 6.66826C8.41394 6.66826 8.81769 6.53986 9.1556 6.30077C9.49351 6.06167 9.74893 5.72365 9.88667 5.33329M2.49467 12.37C3.29467 13.3333 4.78266 13.3333 7.76 13.3333H8.24C11.2173 13.3333 12.706 13.3333 13.506 12.37C14.306 11.406 14.0313 9.94329 13.4827 7.01663C13.0927 4.93663 12.8973 3.89596 12.1567 3.28129C11.4167 2.66663 10.3573 2.66663 8.24066 2.66663H7.75933C5.64266 2.66663 4.584 2.66663 3.84333 3.28129C3.10266 3.89596 2.908 4.93663 2.518 7.01663C1.96933 9.94329 1.69467 11.406 2.49467 12.37Z",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.b8d1135718c96f2441ef7766f0450435.svg";
export { ForwardRef as ReactComponent };